import dayjs from 'dayjs';
import { ITruckImplement } from 'app/shared/model/truck-implement.model';
import { ICompany } from 'app/shared/model/company.model';
import { IUser } from 'app/shared/model/user.model';

export interface IReportDailyVehicle {
  id?: number;
  created?: string | null;
  totalAlerts?: number | null;
  totalSensorAlerts?: number | null;
  totalFenceCircleAlerts?: number | null;
  uptime?: number | null;
  idletime?: number | null;
  odometer?: number | null;
  travelledDistance?: number | null;
  maximumSpeed?: number | null;
  minimumSpeed?: number | null;
  averageSpeed?: number | null;
  maximumLoad?: number | null;
  minimumLoad?: number | null;
  averageLoad?: number | null;
  absActivations?: number | null;
  rssActivations?: number | null;
  brakeActivations?: number | null;
  truckImplement?: ITruckImplement | null;
  company?: ICompany | null;
  user?: IUser | null;
}

export const defaultValue: Readonly<IReportDailyVehicle> = {};
